import { Button } from "@aviary";
import type { ButtonOrLinkType } from "@aviary/components/Button";
import type { PrefetchHOCProps } from "@shared/components/PrefetchHOC";
import { PrefetchHOC } from "@shared/components/PrefetchHOC";
import type { LinkProps } from "@shared/react-router-dom";

type PrefetchLinkProps = LinkProps & PrefetchHOCProps;

const PrefetchButton = PrefetchHOC<ButtonOrLinkType>(Button);
PrefetchButton.displayName = "PrefetchButton";

export type { PrefetchLinkProps };
export { PrefetchButton };
